import React, { useState, useEffect } from 'react';
import { formatDate } from '@/helpers/dateHelpers';

export const Timer: React.FC = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return <div>{formatDate(currentTime)}</div>;
};
